import { useToast } from '@shared/hooks/use-toast';
import { useTranslation } from 'react-i18next';
import { PrintersApiAdapter } from '../adapters/PrintersApiAdapter';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { PrintersModel } from '../models/Printers';
import { Printer } from '../models/PrinterModel';

const printersApi = new PrintersApiAdapter(createHttpClient(apiClientWH));

export const useTogglePrinter = () => {
  const { t } = useTranslation('printersModule');
  const { toast } = useToast();

  const togglePrinter = async (
    printer: PrintersModel,
    onRefresh?: () => void
  ) => {
    try {
      // Convertir PrintersModel a Printer para el adapter
      const printerForApi: Printer = {
        id: printer.id,
        code: printer.id.toString(), // Usar ID como código si no hay code específico
        name: printer.name,
        custom_name: printer.custom_name,
        status: printer.status,
        computer: printer.computer || '',
        active: printer.active,
      };

      await printersApi.togglePrinter(printerForApi);

      toast({
        title: printer.active
          ? t('toast.disabled_title')
          : t('toast.enabled_title'),
        description: `${t('table.printer')}: ${printer.name}`,
      });

      onRefresh?.();
    } catch (error: any) {
      toast({
        title: t('toast.error_title'),
        description:
          error?.response?.data?.message ||
          error?.message ||
          t('toast.error_description'),
        variant: 'destructive',
      });
    }
  };

  return { togglePrinter };
};
